import { UserProfile } from '../types/UserProfile';

function formatPartyName(party: string): string {
  const partyMap: Record<string, string> = {
    Democratic: 'Democratic Party',
    Republican: 'Republican Party',
    Green: 'Green Party',
    Libertarian: 'Libertarian Party',
    Independent: 'Independent'
  };

  return partyMap[party] || party;
}

export function getOrgDisplayName(profile: UserProfile | null): string {
  if (profile?.preferred_org?.name) return profile.preferred_org.name;

  if (profile?.political_party) {
    return formatPartyName(profile.political_party);
  }

  return 'No affiliation selected';
}

export function getOrgLogo(profile: UserProfile | null): string {
  return (
    profile?.preferred_org?.logo_url ||
    profile?.preferred_org?.logo ||
    '/assets/images/default-org-logo.png'
  );
}

export function getOrgCategory(profile: UserProfile | null): string {
  return profile?.preferred_org?.category || 'General';
}

export function getOrgPaymentLink(profile: UserProfile | null): string | null {
  return profile?.preferred_org?.donation_url || null;
}